import { format, isValid, parse } from "date-fns";

// A circuit date is a calendar day, never an instant: the API sends 'yyyy-MM-dd', the pickers hand
// over a Date, and the edit buffer stores ISO strings. `new Date('yyyy-MM-dd')` reads that day as
// UTC midnight, which lands on the day before in every negative offset, and `new Date(null)` is the
// epoch while passing isValid. Everything that turns a stored date into a day goes through here.
//
// Kept out of splitOfflineFlightPrices on purpose: that file imports the reducer types, so the
// reducer itself could not reuse the helper without an import cycle.
export function toDate(value: string | Date | null | undefined): Date | null {
    if (!value) {
        return null;
    }
    if (value instanceof Date) {
        return isValid(value) ? value : null;
    }
    const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ?
        parse(value, 'yyyy-MM-dd', new Date()) :
        new Date(value);
    return isValid(date) ? date : null;
}

export function toDayKey(value: string | Date | null | undefined): string | null {
    const date = toDate(value);
    return date ? format(date, 'yyyy-MM-dd') : null;
}
